import { FC } from 'react';

import AppButton from '@/shared/ui/AppButton';

import {
  ButtonContainer,
  DialogHeader,
  DialogMessage,
  StyledDialog,
} from './DeleteConfirmationModal.styles';

interface Props {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const DeleteConfirmationModal: FC<Props> = ({ open, onClose, onConfirm }) => {
  return (
    <StyledDialog open={open} onClose={onClose}>
      <DialogHeader>Delete file</DialogHeader>
      <DialogMessage>Are you sure that you want to delete this file?</DialogMessage>

      <ButtonContainer>
        <AppButton variant="secondary" onClick={onClose} sx={{ flex: 1 }}>
          No
        </AppButton>
        <AppButton variant="p-alert" onClick={onConfirm} sx={{ flex: 1 }}>
          Yes
        </AppButton>
      </ButtonContainer>
    </StyledDialog>
  );
};

export default DeleteConfirmationModal;
